import React from 'react';
import TemplateProyect from '../TemplateProyect';

function Anime() {
    const infoTect = ["React", "HTML", "CSS", "JavaScript", "Sticker.js", "Sass", "", "", "", ""];
    const infoProyect = [
        "Anime Sticker",
        "https://www.youtube.com/embed/frZMJP636_g",
        "Page showing sticker of anime characters",
        "https://brandongrimaldom.github.io/anime-sticker/",
        "/web-development"
    ];

    return (
        <React.Fragment>
            <TemplateProyect
                title={infoProyect[0]}
                video={infoProyect[1]}
                description={infoProyect[2]}
                github={infoProyect[3]}
                tecfilter={infoTect}
                after={infoProyect[4]}  >
            </TemplateProyect>
        </React.Fragment>
    );
}
export default Anime;